import { Contact, Property } from '@propertypal/shared/src/types/property';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { GetServerSideProps } from 'next/types';
import React, { FunctionComponent, useEffect, useState } from 'react';
import getProperty from '../../../services/property';
import { requireAuthToken } from '../../../utils/auth';

const ALLOWED_DOMAINS = [
  'localhost:*',
  'demo-websites.propertypal.com',
  'awp-dev.propertypal.net',
  'microsites.propertypal.com',
];
const InteractiveSiteMap = dynamic(() => import('../../../components/new-homes/InteractiveSiteMap'), { ssr: false });

export const getServerSideProps: GetServerSideProps = requireAuthToken(async (ctx, store) => {
  const [result, published] = await getProperty(ctx.query.property as string, store.dispatch, ctx, '', true);
  ctx.res.statusCode = published ? 200 : 404;

  ctx.res.removeHeader('X-Frame-Options');
  let agentWebsites: string[] =
    result.data?.contacts?.all.filter((c: Contact) => !!c.websiteUrl).map((c: Contact) => c.websiteUrl) || [];
  if (result.data.account.websiteUrl) agentWebsites.push(result.data.account.websiteUrl);
  agentWebsites = agentWebsites.map((url) => new URL(url).host);

  ctx.res.setHeader(
    'Content-Security-Policy',
    `frame-ancestors 'self' ${ALLOWED_DOMAINS.join(' ')} ${agentWebsites.join(' ')}`,
  );

  return {
    props: {
      property: result.data,
      disableHeader: published,
      disableFooter: published,
      disableScripts: true,
    },
  };
});

const decodeCss = (base64css?: string | string[]) => {
  if (typeof base64css === 'string') {
    return decodeURIComponent(window.atob(base64css));
  }

  return '';
};

const InteractiveSiteMapPage: FunctionComponent<{ property: Property }> = (props) => {
  const router = useRouter();
  const [customCss, setCustomCss] = useState('');

  useEffect(() => {
    setCustomCss(decodeCss(router.query.css));
  }, []);

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <InteractiveSiteMap property={props.property} embed includeExpired />
      {customCss && <style dangerouslySetInnerHTML={{ __html: customCss }} />}
    </div>
  );
};

export default InteractiveSiteMapPage;
